// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Message } from '@shared/utils/DirectMessages/Message';
import { Connection } from '../Connection';
export class FullLogsHelper {
    constructor() {
        this.msgCodes = [];
        this.OnNewMessageHandler = this.OnNewMessageHandler.bind(this);
    }
    start(...msgCodes) {
        this.msgCodes = msgCodes;
        Connection.SubscribeOnFullLoging(this.OnNewMessageHandler);
    }
    stop() {
        Connection.UnSubscribeOnFullLoging();
    }
    getMessages() {
        const msgDict = Connection.GetMessagesList();
        for (const key in msgDict) {
            console.warn(msgDict[key] + '(' + key + ')');
        }
    }
    OnNewMessageHandler(info) {
        if (this.msgCodes.length > 0 &&
            !this.msgCodes.includes(info.MessageCode) &&
            info.MessageCode !== Message.CODE_BUSINESS_REJECT_MESSAGE) {
            return;
        }
        const msgName = info.MessageName + ' (' + info.MessageCode + ')';
        const fieldsTxt = info.Text;
        const fieldsNewTxt = info.TextNew;
        console.warn(`${msgName} ### ${fieldsTxt} ### ${fieldsNewTxt}`);
    }
}
export const flh = new FullLogsHelper();
